import { render } from "./SalaryTable.vue?vue&type=template&id=2d9d2eac"
import script from "./SalaryTable.vue?vue&type=script&lang=js"
export * from "./SalaryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__